module.exports = __webpack_public_path__ + "static/media/undraw_master_plan.d99e3d66.svg";